import { DeviceModel, DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { AdStreamType } from '../../adverts/common';
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- CvsdkError['cause'] type is unknown
export function extractNativeMessage(cause) {
    var nativeMessage = cause === null || cause === void 0 ? void 0 : cause.message;
    if (!nativeMessage) {
        try {
            nativeMessage = JSON.stringify(cause);
        } catch (e) {
            nativeMessage = 'Error converting cause to string';
        }
    }
    return nativeMessage;
}
export function mapAdStreamTypeToConvivaAdPlayer(adStreamType) {
    switch(adStreamType){
        case AdStreamType.InStream:
            return Conviva.Constants.AdPlayer.CONTENT;
        case AdStreamType.Separate:
            return Conviva.Constants.AdPlayer.SEPARATE;
    }
}
export function mapDeviceInfoToConvivaDeviceModel(deviceInfo, convivaAddonConfig) {
    if (convivaAddonConfig.shouldReportChipsetWithModel) {
        return "".concat(deviceInfo.deviceModel, ":").concat(deviceInfo.deviceChipset);
    }
    return deviceInfo.deviceModel;
}
export function mapDeviceInfoTypeToConvivaDeviceType(deviceInfoType) {
    switch(deviceInfoType){
        case 'Console':
            return Conviva.Constants.DeviceType.CONSOLE;
        case 'DESKTOP':
            return Conviva.Constants.DeviceType.DESKTOP;
        case 'Mobile':
            return Conviva.Constants.DeviceType.MOBILE;
        case 'Settop':
            return Conviva.Constants.DeviceType.SETTOP;
        case 'SmartTV':
            return Conviva.Constants.DeviceType.SMARTTV;
        case 'Tablet':
            return Conviva.Constants.DeviceType.TABLET;
        case 'VR':
        // return Conviva.Constants.DeviceType.VR;
        case 'Generic':
        case 'Unknown':
            return null;
    }
}
// eslint-disable-next-line complexity -- No way to reasonably simplify
export function mapDeviceTypeToConvivaDeviceCategory(deviceType, deviceModel) {
    switch(deviceType){
        case DeviceType.Android:
        case DeviceType.Quest:
            return Conviva.Constants.DeviceCategory.ANDROID_DEVICE;
        case DeviceType.Browser:
            return Conviva.Constants.DeviceCategory.WEB;
        case DeviceType.Chromecast:
            return Conviva.Constants.DeviceCategory.CHROMECAST;
        case DeviceType.WebOS:
            return Conviva.Constants.DeviceCategory.LG_TV;
        case DeviceType.Prospero:
        case DeviceType.WebMaf:
            return Conviva.Constants.DeviceCategory.PLAYSTATION;
        case DeviceType.Tizen:
            return Conviva.Constants.DeviceCategory.SAMSUNG_TV;
        case DeviceType.Vidaa:
        case DeviceType.Vizio:
            return Conviva.Constants.DeviceCategory.SMART_TV;
        case DeviceType.XboxOne:
        case DeviceType.XboxSeries:
        case DeviceType.WinUI2:
            return Conviva.Constants.DeviceCategory.XBOX;
        case DeviceType.Xfinity:
        case DeviceType.OneSdk:
        case DeviceType.MultiChoiceRdk:
        case DeviceType.Kpn:
        case DeviceType.RDK:
        case DeviceType.YouView:
        case DeviceType.Netgem:
        case DeviceType.Zenterio:
        case DeviceType.Kepler:
            return Conviva.Constants.DeviceCategory.SET_TOP_BOX;
        case DeviceType.Ion:
            if (deviceModel == DeviceModel.PS4) return Conviva.Constants.DeviceCategory.PLAYSTATION;
            return null;
        case DeviceType.Llama:
        case DeviceType.Generic:
            return null;
    }
}
export function mapSessionStateToConvivaPlayerState(state) {
    switch(state){
        case InternalSessionState.Loading:
        case InternalSessionState.PlayerLoading:
        case InternalSessionState.Rebuffering:
        case InternalSessionState.Seeking:
        case InternalSessionState.CsaiTransition:
            return Conviva.Constants.PlayerState.BUFFERING;
        case InternalSessionState.Playing:
            return Conviva.Constants.PlayerState.PLAYING;
        case InternalSessionState.Paused:
            return Conviva.Constants.PlayerState.PAUSED;
        case InternalSessionState.Finished:
        case InternalSessionState.Stopped:
            return Conviva.Constants.PlayerState.STOPPED;
        case InternalSessionState.Initialized:
        case InternalSessionState.Stopping:
        case InternalSessionState.WaitingForPin:
            return null;
    }
}
export function mapAdType(adStreamType) {
    switch(adStreamType){
        case AdStreamType.InStream:
            return Conviva.Constants.AdType.SERVER_SIDE;
        case AdStreamType.Separate:
            return Conviva.Constants.AdType.CLIENT_SIDE;
    }
}
export function sanitizeGatewayUrl(gatewayUrl) {
    return gatewayUrl.replace(/\/$/, '');
}

//# sourceMappingURL=metadata-helper.js.map